import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectFunctionApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'project-function'
  }

}